import DefaultLayout from "./common/components/DefaultLayout";
import ErrorPage from "./pages/Error";
import EmployeeRegistration from "./pages/EmployeeRegistration";
import PainterRegistration from "./pages/PainterRegistration";
import DealerRegistration from "./pages/DealerRegistration";
import EmployeeCardPreview from "./pages/EmployeeCardPreview";
import DealerCardPreview from "./pages/DealerCardPreview";
import PainterCardPreview from "./pages/PainterCardPreview";

export const routes = [
  {
    path: "/",
    component: <EmployeeRegistration />,
    layout: DefaultLayout,
  },
  {
    path: "/painter",
    component: <PainterRegistration />,
    layout: DefaultLayout,
  },
  {
    path: "/dealer",
    component: <DealerRegistration />,
    layout: DefaultLayout,
  },
  {
    path: "/card-preview",
    component: <EmployeeCardPreview />,
    layout: DefaultLayout,
  },
  {
    path: "/dealer-card-preview",
    component: <DealerCardPreview />,
    layout: DefaultLayout,
  },
  {
    path: "/painter-card-preview",
    component: <PainterCardPreview />,
    layout: DefaultLayout,
  },
  {
    path: "*",
    component: <ErrorPage />,
    layout: DefaultLayout,
  },
];
